<template>
  <div>
    <el-form
      label-position="top"
      :model="formSignup"
      class="text-left pd-x-1 set-form-regis"
      :rules="rules"
      ref="formSignup"
    >
      <el-row :gutter="30">
        <el-col :span="9" :sm="4" class="pd-r-less">
          <el-form-item label="คำนำหน้าชื่อ" prop="prefix">
            <el-select
              v-model="formSignup.prefix"
              placeholder="คำนำหน้าชื่อ"
              style="width: 100%"
            >
              <el-option
                v-for="item in prefixList"
                :key="item.id"
                :label="item.label"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="15" :sm="8">
          <el-form-item label="ชื่อภาษาไทย" prop="nameTh">
            <el-input v-model="formSignup.nameTh"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24" :sm="12">
          <el-form-item label="นามสกุลภาษาไทย" prop="lastNameTh">
            <el-input v-model="formSignup.lastNameTh"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24" :sm="12">
          <el-form-item label="ชื่อภาษาอังกฤษ" prop="nameEn">
            <el-input v-model="formSignup.nameEn"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24" :sm="12">
          <el-form-item label="นามสกุลภาษาอังกฤษ" prop="lastNameEn">
            <el-input v-model="formSignup.lastNameEn"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24" :sm="12">
          <el-form-item label="หมายเลขโทรศัพท์" prop="phoneNumber">
            <VuePhoneNumberInput
              v-model="formSignup.phoneNumber"
              @update="updatePhoneNumber"
              :default-country-code="phoneNumber.countryCode"
              color="#353535"
              error-color="#C81800"
              valid-color="#00C88C"
              :error="!phoneNumber.numberValid"
            />
          </el-form-item>
        </el-col>
        <el-col :span="24" :sm="12">
          <el-form-item label="หมายเลขบัตรประชาชน" prop="idCard">
            <el-input
              v-model="formSignup.idCard"
              v-mask="'#-####-#####-##-#'"
              maxlength="17"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24" :sm="12">
          <el-form-item label="วัน/เดือน/ปีเกิด" prop="birthDay">
            <el-date-picker
              v-model="formSignup.birthDay"
              type="date"
              class="width-100"
              :picker-options="{
                disabledDate(time) {
                  return time.getTime() > Date.now();
                },
              }"
            >
            </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="24" :sm="12">
          <el-form-item label="ตำแหน่งงาน" prop="position">
            <el-input v-model="formSignup.position"></el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="30">
        <el-col :span="24" :sm="12">
          <el-form-item label="ที่อยู่" prop="address">
            <el-input v-model="formSignup.address"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24" :sm="12" class="pd-b-5">
          <el-form-item label="รหัสไปรษณีย์" prop="postcode">
            <ThailandAutoComplete
              v-model="formSignup.postcode"
              type="zipcode"
              @select="selectAddress"
              @input="checkValid('postcode')"
              color="#409EFF"
              class="form-input"
            />
          </el-form-item>
        </el-col>
        <el-col :span="24" :sm="12" class="pd-b-5">
          <el-form-item label="ตำบล/แขวง" prop="subDistrict">
            <ThailandAutoComplete
              v-model="formSignup.subDistrict"
              type="district"
              @select="selectAddress"
              @input="checkValid('subDistrict')"
              color="#409EFF"
              class="form-input"
            />
          </el-form-item>
        </el-col>
        <el-col :span="24" :sm="12" class="pd-b-5">
          <el-form-item label="อำเภอ/เขต" prop="district">
            <ThailandAutoComplete
              v-model="formSignup.district"
              type="amphoe"
              @select="selectAddress"
              @input="checkValid('district')"
              color="#409EFF"
              class="form-input"
            />
          </el-form-item>
        </el-col>
        <el-col :span="24" :sm="12" class="pd-b-5">
          <el-form-item label="จังหวัด" prop="province">
            <ThailandAutoComplete
              v-model="formSignup.province"
              type="province"
              @select="selectAddress"
              @input="checkValid('province')"
              color="#409EFF"
              class="form-input"
            />
          </el-form-item>
        </el-col>
        <el-col :span="24" class="pd-y-3">
          <el-button
            @click="nextStep('formSignup')"
            type="primary"
            class="width-100 button-auth"
            round
            >{{ from == "signup" ? "ขั้นตอนต่อไป" : "บันทึก" }}</el-button
          >
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>

<script>
import Avatar from "vue-avatar";
import VuePhoneNumberInput from "vue-phone-number-input";
import "vue-phone-number-input/dist/vue-phone-number-input.css";
import ThailandAutoComplete from "vue-thailand-address-autocomplete";
import { HTTP } from "@/service/axios.js";

export default {
  components: {
    Avatar,
    VuePhoneNumberInput,
    ThailandAutoComplete,
  },
  props: {
    value: {
      type: Object,
      default() {
        return null;
      },
    },
    from: {
      type: String,
      default() {
        return "signup";
      },
    },
  },
  computed: {
    prefixList() {
      return this.$store.state.prefixList;
    },
  },
  data() {
    var validatePhoneNumber = (rule, value, callback) => {
      if (!this.phoneNumber.numberValid) {
        callback(new Error("กรุณากรอกหมายเลขโทรศัพท์ให้ถูกต้อง"));
      } else {
        callback();
      }
    };
    var validateIdCard = (rule, value, callback) => {
      if (!this.checkID(value)) {
        callback(new Error("กรุณากรอกหมายเลขบัตรประชาชนให้ถูกต้อง"));
      } else {
        callback();
      }
    };
    var validateThai = (rule, value, callback) => {
      let regx = /^[^a-z^A-Z]+$/i;
      if (!regx.test(value)) {
        callback(new Error("กรุณากรอกตัวอักษรภาษาไทย"));
      } else {
        callback();
      }
    };
    var validateEng = (rule, value, callback) => {
      let regx = /^[^ก-๛]+$/i;
      if (!regx.test(value)) {
        callback(new Error("กรุณากรอกตัวอักษรภาษาอังกฤษ"));
      } else {
        callback();
      }
    };
    return {
      formSignup: {
        prefix: "",
        nameTh: "",
        lastNameTh: "",
        nameEn: "",
        lastNameEn: "",
        phoneNumber: "",
        idCard: "",
        birthDay: "",
        position: "",
        address: "",
        postcode: "",
        subDistrict: "",
        district: "",
        province: "",
      },
      rules: {
        prefix: [
          {
            required: true,
            message: "กรุณาเลือกคำนำหน้าชื่อ",
            trigger: ["blur", "change"],
          },
        ],
        nameTh: [
          { required: true, message: "กรุณากรอกชื่อภาษาไทย", trigger: "blur" },
          { validator: validateThai, trigger: "blur" },
        ],
        lastNameTh: [
          {
            required: true,
            message: "กรุณากรอกนามสกุลภาษาไทย",
            trigger: "blur",
          },
          { validator: validateThai, trigger: "blur" },
        ],
        nameEn: [
          {
            required: true,
            message: "กรุณากรอกชื่อภาษาอังกฤษ",
            trigger: "blur",
          },
          { validator: validateEng, trigger: "blur" },
        ],
        lastNameEn: [
          {
            required: true,
            message: "กรุณากรอกนามสกุลภาษาอังกฤษ",
            trigger: "blur",
          },
          { validator: validateEng, trigger: "blur" },
        ],
        phoneNumber: [
          {
            required: true,
            message: "กรุณากรอกหมายเลขโทรศัพท์",
            trigger: "blur",
          },
          { validator: validatePhoneNumber, trigger: "blur" },
        ],
        idCard: [
          {
            required: true,
            message: "กรุณากรอกหมายเลขบัตรประชาชน",
            trigger: "blur",
          },
          { validator: validateIdCard, trigger: "blur" },
        ],
        birthDay: [
          {
            type: "date",
            required: true,
            message: "กรุณาเลือกวันเกิด",
            trigger: "change",
          },
        ],
        position: [
          {
            required: true,
            message: "กรุณากรอกตำแหน่งงาน",
            trigger: "blur",
          },
        ],
        address: [
          {
            required: true,
            message: "กรุณากรอกที่อยู่",
            trigger: "blur",
          },
        ],
        postcode: [
          {
            required: true,
            message: "กรุณากรอกรหัสไปรษณีย์",
            trigger: ["blur", "change"],
          },
          {
            min: 5,
            max: 5,
            message: "กรุณากรอกรหัสไปรษณีย์ให้ถูกต้อง",
            trigger: ["blur", "change"],
          },
        ],
        subDistrict: [
          {
            required: true,
            message: "กรุณากรอกตำบล",
            trigger: ["blur", "change"],
          },
        ],
        district: [
          {
            required: true,
            message: "กรุณากรอกอำเภอ",
            trigger: ["blur", "change"],
          },
        ],
        province: [
          {
            required: true,
            message: "กรุณากรอกจังหวัด",
            trigger: ["blur", "change"],
          },
        ],
      },

      urlImage:
        "https://i.pinimg.com/originals/3b/8a/d2/3b8ad2c7b31be2caf24321c852103598a.jpg",

      phoneNumber: {
        countryCode: "TH",
        formatNational: "",
        numberValid: true,
      },
      idCardConst: "",
    };
  },
  watch: {
    value() {
      this.setValue();
    },
  },
  mounted() {
    this.setValue();
  },
  methods: {
    setValue() {
      console.log("this.value", this.value);
      if (this.value) {
        this.formSignup = {
          prefix: this.value.prefix ? this.value.prefix : "",
          nameTh: this.value.nameTh,
          lastNameTh: this.value.lastNameTh,
          nameEn: this.value.nameEn,
          lastNameEn: this.value.lastNameEn,
          phoneNumber: this.value.phoneNumberObj.formatNational,
          idCard: this.value.idCard,
          birthDay: this.value.birthDay ? new Date(this.value.birthDay) : "",
          position: this.value.position,
          address: this.value.address,
          postcode: this.value.postcode,
          subDistrict: this.value.subDistrict,
          district: this.value.district,
          province: this.value.province,
        };
        this.image = this.value.image;
        this.phoneNumber = {
          countryCode: this.value.phoneNumberObj.countryCode,
          formatNational: this.value.phoneNumberObj.formatNational,
          numberValid: this.value.phoneNumberObj.numberValid,
        };

        this.idCardConst = this.value.idCard;
      }
    },
    updatePhoneNumber(payload) {
      this.formSignup.phoneNumber = payload
        ? payload.phoneNumber.replace(/[\s (]/g, "")
        : "";
      this.phoneNumber.countryCode = payload.countryCode;
      this.phoneNumber.formatNational = payload.formatNational;
      this.phoneNumber.numberValid = payload.isValid;
      this.$refs["formSignup"].validateField("phoneNumber");
    },
    checkID(id) {
      if (id == "") {
        return true;
      }

      let idReplace = id.replace(/[-]/g, "");
      let sum = 0;
      for (let i = 0; i < 12; i++) {
        sum += parseFloat(idReplace.charAt(i)) * (13 - i);
      }
      if ((11 - (sum % 11)) % 10 != parseFloat(idReplace.charAt(12))) {
        return false;
      } else {
        return true;
      }
    },
    selectAddress(address) {
      this.formSignup.postcode = address.zipcode;
      this.formSignup.subDistrict = address.district;
      this.formSignup.district = address.amphoe;
      this.formSignup.province = address.province;
      this.$refs["formSignup"].validateField("postcode");
      this.$refs["formSignup"].validateField("subDistrict");
      this.$refs["formSignup"].validateField("district");
      this.$refs["formSignup"].validateField("province");
    },
    nextStep(formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          let indentification = await this.checkIndentificationId();
          if (indentification || this.idCardConst == this.formSignup.idCard) {
            let obj = JSON.parse(JSON.stringify(this.formSignup));
            obj["phoneNumberObj"] = this.phoneNumber;
            this.$emit("setFormStep", obj);
          } else {
            this.$message.error("เลขบัตรประชาชนนี้ถูกใช้งานแล้ว");
          }
        }
      });
    },
    async checkIndentificationId() {
      let status = false;

      let obj = {
        id: this.formSignup.idCard,
      };

      await HTTP.post(`indentification`, obj)
        .then((res) => {
          if (res.data.success) {
            status = true;
          } else {
            status = false;
          }
        })
        .catch((e) => {
          console.log("signup error", e);
          status = false;
        });

      return status;
    },
    checkValid(field) {
      this.$refs["formSignup"].validateField(field);
    },
  },
};
</script>
